import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const paytmApi = createApi({
  reducerPath: "paytm",
  baseQuery: fetchBaseQuery({
    baseUrl: ``,
  }),
  endpoints: (builder) => {
    return {
      initiatePayment: builder.mutation({
        query: (body) => {
          return {
            url: `/api/initiate`,
            method: "POST",
            body,
          };
        },
      }),
    };
  },
});

export const { useInitiatePaymentMutation } = paytmApi;
export { paytmApi };
